<template>
  <div class="modal fade" id="viewModal">
    <div class="modal-dialog modal-lg">
    <div class="modal-content">
        <div class="modal-header bg-aqua">
        <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
        >
            <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Payment Details</h4>
        </div>
        <div class="modal-body">
        <!-- right column -->
        <div class="row">
            <div class="col-md-6">
            <!-- Profile Image -->
            <div class="card card-primary card-outline">
                <div class="card-body box-profile">
                <ul class="list-group mb-3">
                    <li class="list-group-item">
                    <b>Branch Name</b>
                    <a class="pull-right" v-if="empInfo.branch">{{ empInfo.branch.name }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Employee Name</b>
                    <a class="pull-right" v-if="empInfo.employee">{{ empInfo.employee.name }} ({{ empInfo.employee.code }})</a>
                    </li>
                    <li class="list-group-item">
                    <b>Employee Contact</b>
                    <a class="pull-right" v-if="empInfo.employee">{{ empInfo.employee.mobile }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Salary</b>
                    <a class="pull-right">{{ empInfo.salary }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Payment Mode</b>
                    <a class="pull-right">{{ empInfo.payMode }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Transfer Mode</b>
                    <a class="pull-right">{{ empInfo.transferMode }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>UTR Transaction No</b>
                    <a class="pull-right">{{ empInfo.utrTransactionNo }}</a>
                    </li>
                </ul>
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card -->
            </div>
            <!-- /.col -->
            <div class="col-md-6">
            <!-- Profile Image -->
            <div class="card card-primary card-outline">
                <div class="card-body box-profile">
                <ul class="list-group mb-3">
                    <li class="list-group-item">
                    <b>Branch Ledger</b>
                    <a class="pull-right" v-if="empInfo.branch_ledger">{{ empInfo.branch_ledger.ledger.name }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Transaction Date</b>
                    <a class="pull-right">{{ empInfo.transactionDate }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Cheque Date</b>
                    <a class="pull-right">{{ empInfo.chequeDate }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Cheque Number</b>
                    <a class="pull-right">{{ empInfo.chequeNo }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Bank Name</b>
                    <a class="pull-right" v-if="empInfo.bank">{{ empInfo.bank.name }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Saving Account Number</b>
                    <a class="pull-right">{{ empInfo.savingAcccountNo }}</a>
                    </li>
                    <li class="list-group-item">
                    <b>Remark</b>
                    <a class="pull-right">{{ empInfo.remark }}</a>
                    </li>
                </ul>
                </div>
                <!-- /.card-body -->
            </div>
            <!-- /.card -->
            </div>
            <!-- /.col -->
        </div>
        </div>
        <div class="modal-footer text-center">
        <button
            type="button"
            class="btn btn-primary"
            data-dismiss="modal"
        >
            CLOSE
        </button>
        </div>
    </div>
    <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script>
export default {
  name: 'ViewSalaryRecords',
  props: ['empInfo']
}
</script>



// WEBPACK FOOTER //
// ViewSalaryRecords.vue?640d52d7